export enum CallOutcomeContentTabs {
  CustomOutcomes = 'custom-outcomes',
  SystemOutcomes = 'system-outcomes',
}

export enum SystemCallOutcomeName {
  Interested = 'Interested',
  CallbackLater = 'Callback Later',
  NotInterested = 'Not Interested',
  Followup = 'Follow-up',
  WrongNumber = 'Wrong Number',
  NoAnswer = 'No Answer',
  LeftVoiceMail = 'Left Voice Mail',
  NotInService = 'Not In Service',
  GateKeeper = 'Gate Keeper',
  DoNotContact = 'Do Not Contact',
}
